import React, { useContext } from "react";
import copy from "../icons/copy.svg";
import { UserContext } from "../providers/userData";
import { AppDataContext } from "../providers/appData";
import { toast } from "react-toastify";
import Layout from "../Layout";
import { Link, useHistory } from "react-router-dom";

function XendifyFund() {
  const { user, userDispatch } = useContext(UserContext);
  const { appData } = useContext(AppDataContext);
  const history = useHistory();

  document.title = "Fund Wallet with Bank-" + appData.business.name;

  const Copy = (text) => {
    navigator.clipboard.writeText(text).then(() => toast("Copied"));
  };

  return (
    <Layout PageName={"Fund via Xendify"}>
      <div className="divide-y-2 divide-primary-gray">
        <div className="flex flex-col mt-8 space-y-3.5 pb-9">
          <h6 className="text-center fs-1">
            Transfer into any of your dedicated bank accounts for auto wallet
            funding
          </h6>
          <div className="flex justify-between ">
            {" "}
            <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
              Status:
            </p>
            <p className="font-semibold text-sm text-red-500 md:text-base ">
              {appData.master_settings.fund_status_bank * 1 === 0 ? (
                <p className="font-semibold text-sm text-green-500 ">Working</p>
              ) : (
                <p className="font-semibold text-sm text-red-500 ">Downtime</p>
              )}
            </p>
          </div>
          <div className="flex justify-between ">
            {" "}
            <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
              Delivery time: :
            </p>
            <p className="font-semibold text-sm text-gray-700 dark:text-gray-200 md:text-base">
              1 - 3 Minutes
            </p>
          </div>

          <div className="flex justify-between ">
            {" "}
            <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
              Transaction Fee:
            </p>
            <p className="font-semibold text-sm text-gray-700 dark:text-gray-200 md:text-base">
              ₦26.75
            </p>
          </div>
        </div>
        <div className="pt-1 "></div>
      </div>

      {appData.master_settings.fund_status_bank * 1 === 0 && (
        <div className="flex flex-wrap gap-2.5">
          {user.data.net_account_number && (
            <div className=" rounded overflow-hidden shadow shadow-lg h-auto  bg-primary-orange text-white  p-2  ">
              <div className="flex flex-col space-y-3">
                <div className="  items-center justify-start md:space-x-2 ">
                  <p className="font-bold text-white text-sm">Bank: NET MFB </p>
                </div>
                <div className="flex  items-center justify-start space-x-2 ">
                  <p className="font-bold text-white text-sm">
                    Account Number: {user.data.net_account_number}
                  </p>
                  <div className="flex gap-1 ">
                    <p className="text-xx  text-white">copy</p>
                    <img
                      src={copy}
                      alt="copy"
                      className=""
                      onClick={() => Copy(user.data.net_account_number)}
                    />
                  </div>
                </div>
                <div className="flex items-center justify-start">
                  <p className="font-bold text-white text-sm">
                    Account Name: DN-{" "}
                    {`${user.data.firstname} ${user.data.othername} ${user.data.lastname}`}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </Layout>
  );
}

export default XendifyFund;
